import {useEffect, useState} from "react";
import {clearWishlist, getWishlist, type Product} from "@corporatesclub/shared";
import {DsButton, DsEmptyState} from "@corporatesclub/ui";
import {ProductCard} from "./ProductCard";
import {useI18n} from "./I18nProvider";

export function WishlistView() {
  const {t} = useI18n();
  const [items, setItems] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);
  const load = () => getWishlist().then((r) => setItems(r.items)).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);
  async function onClear() {
    await clearWishlist();
    setItems([]);
    window.dispatchEvent(new CustomEvent("wishlist-updated", {detail: 0}));
  }
  if(loading) {
    return (
      <div className="cc-wishlist">
        <div className="cc-wishlist__loading">
          <div className="cc-wishlist__spinner" aria-hidden="true" />
          <span>{t("Loading products...")}</span>
        </div>
      </div>
    );
  }
  if(!items.length) {
    return (
      <div className="cc-wishlist">
        <div className="cc-wishlist__empty">
          <DsEmptyState
            icon={<i className="fa fa-heart-o" aria-hidden="true" />}
            title={t("You have not added any products to your wishlist. Add one right now!")}
          />
        </div>
      </div>
    );
  }
  return (
    <div className="cc-wishlist">
      <header className="cc-wishlist__hero">
        <div className="cc-wishlist__heroInner">
          <div className="cc-wishlist__heroCopy">
            <h1 className="cc-wishlist__title">{t("Wishlist")}</h1>
            <p className="cc-wishlist__count">{items.length} {t("products")}</p>
          </div>
          <DsButton type="button" variant="outline" size="sm" className="cc-wishlist__clear anim" onClick={onClear}>
            <i className="fa fa-trash-o" aria-hidden="true" /> {t("Remove all products")}
          </DsButton>
        </div>
      </header>
      <div className="cc-wishlist__grid">
        <div className="cc-productGridWrap">
          <div className="cc-productGrid">
            {items.map((p) => <ProductCard key={p.id} product={p} showWishlist />)}
          </div>
        </div>
      </div>
    </div>
  );
}
